<template>
    <div class="container-fluid">
        <Breadcrumb title="Dashboard" v-bind:button-show="false"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body" v-if="isAdmin">
                        <div class="input-group form-group col-12" style="margin-bottom: 0">
                            <div class="col-lg-11 col-md-10 col-sm-8" style="margin-bottom: 0">
                                <treeselect placeholder="Filter by User"
                                            v-model="userSearch"
                                            :options="userSelect"
                                            :load-options="loadUsers"
                                            :auto-load-root-options="false"/>
                            </div>
                            <div class="col-lg-1 col-md-2 col-sm-2 w-100">
                                <button v-on:click="getAllData" class="btn btn-info" type="button">Filter</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <line-chart style="max-height:320px;position:relative;"
                                    :chartData="overallData"
                                    :options="overallOptions"/>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div class="form-group">
                            <treeselect placeholder="Select Mail Provider"
                                        v-model="providerFilter"
                                        :options="providerList"
                                        :clearable="false"
                                        @select="chartRedraw"/>
                        </div>
                        <line-chart style="max-height:500px;position:relative;"
                                    :chartData="detailedData"
                                    :options="detailedOptions"/>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-bordered " id="countsTable">
                                <thead>
                                <tr>
                                    <th></th>
                                    <th colspan="2">Total Relay</th>
                                    <th colspan="2">Neutral + Good</th>
                                    <th colspan="2">Poor</th>
                                </tr>
                                <tr>
                                    <th>Group Name</th>
                                    <th>Net</th>
                                    <th>VPS</th>
                                    <th>Net</th>
                                    <th>VPS</th>
                                    <th>Net</th>
                                    <th>VPS</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(row, index) in tableData" :key="index">
                                    <td class="align-middle">{{row.group.name}}</td>
                                    <td class="align-middle">{{row.counts.totalNet}}</td>
                                    <td class="align-middle">{{row.counts.totalVps}}</td>
                                    <td class="align-middle">{{row.counts.goodNet}}</td>
                                    <td class="align-middle">{{row.counts.goodVps}}</td>
                                    <td class="align-middle">{{row.counts.badNet}}</td>
                                    <td class="align-middle">{{row.counts.badVps}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Breadcrumb from '../components/Breadcrumb';
    import DashboardService from '../services/DashboardService';
    import LineChart from '../components/LineChart.vue';
    import moment from 'moment';
    import Treeselect from '@riophae/vue-treeselect';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import UserService from '../services/UserService';

    export default {
        name: 'Dashboard',
        components: {
            Breadcrumb, LineChart, Treeselect
        },
        data() {
            return {
                lineColors: [
                    '#c91d1d',
                    '#04c909',
                    '#c61dc9',
                    '#c9c604',
                    '#3f1dc9',
                    '#c9741d',
                    '#86c98d',
                    '#64aac9',
                    '#c982c5',
                    '#c6c976',
                    '#000000',
                    '#7d7d7d',
                    '#f38d03',
                    '#2dc9a1',
                    '#26ff04',
                    '#f97e7e'
                ],
                overallOptions: {
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            ticks: {beginAtZero: true}
                        }],
                        xAxes: [{
                            ticks: {
                                callback: value => {
                                    return moment.unix(value).utc().format('H:mm');
                                },
                                source: 'lables',
                            }
                        }]
                    },
                    title: {
                        display: true,
                        fontSize: 16,
                        text: 'Overall traffic',
                    },
                    elements: {
                        point: {radius: 0}
                    },
                    legend: {
                        position: 'left',
                    },
                    tooltips: {
                        callbacks: {
                            title: function (titleItems) {
                                return moment.unix(titleItems[0].label).utc().format('H:mm');
                            }
                        }
                    }
                },
                detailedOptions: {
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            ticks: {beginAtZero: true}
                        }],
                        xAxes: [{
                            ticks: {
                                callback: value => {
                                    return moment.unix(value).utc().format('H:mm');
                                },
                                source: 'lables',
                            }
                        }]
                    },
                    title: {
                        display: true,
                        fontSize: 12,
                        text: 'Detailed traffic',
                    },
                    elements: {
                        point: {radius: 0}
                    },
                    legend: {
                        position: 'left',
                        labels: {boxWidth: 20, padding: 20},
                    },
                    tooltips: {
                        callbacks: {
                            title: function (titleItems) {
                                return moment.unix(titleItems[0].label).utc().format('H:mm');
                            }
                        }
                    }

                },
                overallData: null,
                detailedData: null,
                overallTemplate: {
                    labels: [],
                    datasets: [
                        {
                            label: 'Total',
                            borderColor: '#03a9f3',
                            backgroundColor: 'rgba(3,169,243,0.07)',
                            data: [],
                        }, {
                            label: 'Delivered',
                            fill: false,
                            borderColor: '#61f885',
                            data: [],
                        }
                        , {
                            label: 'Bounced',
                            fill: false,
                            borderColor: '#f8cd70',
                            data: [],
                        }
                    ]
                },
                detailedTemplate: {
                    labels: [],
                    datasets: [],
                },
                detailedCache: null,
                providerList: [{id: 0, label: 'All providers'}],
                providerFilter: 0,
                userSearch: null,
                userSelect: null,
                isAdmin: false,
                tableData: null
            }
        },
        mounted() {
            this.isAdmin = this.$store.getters.isAdmin;
            this.getAllData();
        },
        methods: {
            getAllData() {
                this.getChartData();
                this.getTableData();
            },
            loadUsers({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userSelect = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            },
            getChartData: function () {
                this.providerList = [{id: 0, label: 'All providers'}];
                DashboardService.getSpeedChartData(JSON.stringify({
                    'type': 'overall',
                    'userId': this.userSearch
                })).then(response => {
                    let overallChartData = JSON.parse(JSON.stringify(this.overallTemplate));
                    overallChartData.labels = response.data.labels;
                    overallChartData.datasets[0].data = response.data.total;
                    overallChartData.datasets[1].data = response.data.sent;
                    overallChartData.datasets[2].data = response.data.bounce;
                    this.overallData = overallChartData;
                });
                DashboardService.getSpeedChartData(JSON.stringify({
                    'type': 'detailed',
                    'userId': this.userSearch
                })).then(response => {
                    this.detailedCache = response.data;
                    for (let providerName in this.detailedCache.chartData) {
                        this.providerList.push({id: providerName, label: providerName});
                    }
                    this.drawDefaulDetailedChart();
                });
            },
            chartRedraw(value) {
                if (value.id === 0) {
                    this.drawDefaulDetailedChart();
                    return;
                }
                let detailedChartData = JSON.parse(JSON.stringify(this.overallTemplate));
                detailedChartData.labels = this.detailedCache.labels;
                detailedChartData.datasets[0].data = this.detailedCache.chartData[value.id].total;
                detailedChartData.datasets[1].data = this.detailedCache.chartData[value.id].sent;
                detailedChartData.datasets[2].data = this.detailedCache.chartData[value.id].bounce;
                this.detailedData = detailedChartData;
            },
            drawDefaulDetailedChart() {
                let detailedChartData = JSON.parse(JSON.stringify(this.detailedTemplate));
                detailedChartData.labels = this.detailedCache.labels;
                let colorIndex = 0;
                for (let providerName in this.detailedCache.chartData) {
                    if (colorIndex >= this.lineColors.length) {
                        colorIndex = 0;
                    }
                    detailedChartData.datasets.push({
                        label: providerName,
                        fill: false,
                        borderColor: this.lineColors[colorIndex],
                        data: this.detailedCache.chartData[providerName].total,
                    });
                    colorIndex++;
                }
                this.detailedData = detailedChartData;
            },
            getTableData: function () {
                DashboardService.getTableData(JSON.stringify({userId: this.userSearch})).then(response => {
                        this.tableData = response.data;
                    }
                )
            },
        }
    }
</script>

<style scoped>

</style>
